import React from 'react'
import './cosmos-stage.css'

/** Living scene behind every Brain Power game: breathing orb, dust, a tilted floor. */
export function CosmosStage({ accent = '#22d3ee', wide = false, children }) {
  return (
    <div className={`cosmos-stage${wide ? ' is-wide' : ''}`} style={{ '--stage-accent': accent }}>
      <div className="cosmos-stage__sky" aria-hidden="true">
        <span className="cosmos-stage__orb" />
        <span className="cosmos-stage__orb cosmos-stage__orb--far" />
        <span className="cosmos-stage__floor" />
        <i /><i /><i /><i /><i /><i />
      </div>
      <div className="cosmos-stage__card">{children}</div>
    </div>
  )
}
